/*
 * AB Jewellery — collection filtering & sorting.
 * Without JavaScript the filter form submits normally (GET).
 * With JavaScript, results update in place via the Section Rendering API.
 */
(function () {
  'use strict';
  var AB = window.AB || {};
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function Collection(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.baseUrl = root.getAttribute('data-url');
    this.form = qs('[data-ab-facet-form]', root);
    this.controller = null;
    this.bind();
  }

  Collection.prototype.bind = function () {
    var self = this;
    var debounced = (AB.debounce || function (f) { return f; })(function () { self.apply(); }, 350);

    this.root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-ab-facet-input]')) return;
      if (event.target.type === 'number') debounced();
      else self.apply();
    });

    this.root.addEventListener('submit', function (event) {
      if (!event.target.matches('[data-ab-facet-form]')) return;
      event.preventDefault();
      self.apply();
      var dialog = event.target.closest('dialog');
      if (dialog && AB.dialog) AB.dialog.close(dialog);
    });

    this.root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-ab-facet-link]');
      if (!link) return;
      event.preventDefault();
      self.load(link.getAttribute('href'));
    });

    window.addEventListener('popstate', function () {
      self.load(window.location.href, true);
    });
  };

  Collection.prototype.queryString = function () {
    if (!this.form) return '';
    var data = new FormData(this.form);
    var params = new URLSearchParams();
    data.forEach(function (value, key) { if (value !== '') params.append(key, value); });
    return params.toString();
  };

  Collection.prototype.apply = function () {
    var qsStr = this.queryString();
    this.load(this.baseUrl + (qsStr ? '?' + qsStr : ''));
  };

  Collection.prototype.load = function (url, fromHistory) {
    var self = this;
    var target = new URL(url, window.location.origin);
    var fetchUrl = new URL(target.toString());
    fetchUrl.searchParams.set('section_id', this.sectionId);

    if (this.controller) this.controller.abort();
    this.controller = 'AbortController' in window ? new AbortController() : null;
    var results = qs('[data-ab-collection-results]', this.root);
    results.setAttribute('aria-busy', 'true');

    fetch(fetchUrl.toString(), this.controller ? { signal: this.controller.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-ab-collection-results]', '[data-ab-active-filters]', '[data-ab-collection-count]', '[data-ab-facet-body]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var current = qs(sel, self.root);
          if (!fresh || !current) return;
          if (sel === '[data-ab-facet-body]') {
            var open = qsa('details', current).map(function (d) { return d.open; });
            current.innerHTML = fresh.innerHTML;
            qsa('details', current).forEach(function (d, i) { if (open[i] !== undefined) d.open = open[i]; });
          } else {
            current.innerHTML = fresh.innerHTML;
          }
        });
        var sort = qs('select[name="sort_by"]', self.root);
        var freshSort = doc.querySelector('select[name="sort_by"]');
        if (sort && freshSort) sort.value = freshSort.value;
        if (!fromHistory) window.history.pushState({}, '', target.pathname + target.search);
        if (AB.wishlist) AB.wishlist.sync();
        if (AB.initReveal) AB.initReveal();
        var count = qs('[data-ab-collection-count]', self.root);
        if (count && AB.announce) AB.announce(count.textContent.trim());
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') window.location.href = target.toString();
      })
      .finally(function () { results.removeAttribute('aria-busy'); });
  };

  function boot() {
    qsa('[data-ab-collection]').forEach(function (root) {
      if (root.dataset.abInit) return;
      root.dataset.abInit = 'true';
      new Collection(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
